import React from 'react';
import {
  IconButton,
  Icons,
  Typography,
  useTheme,
} from '@ublend-npm/aulaui-core';
import { createStyles } from './CloseButton.styles';

interface CloseButtonProps {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
  sx?: Record<string, unknown>;
}

const CloseButton = ({
  onClick,
  disabled = false,
  label = 'Close',
  sx,
}: CloseButtonProps) => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <IconButton
      aria-label={label}
      onClick={onClick}
      disabled={disabled}
      sx={{ ...styles.button, ...sx }}
    >
      <Typography component="span" sx={styles.label}>
        {label}
      </Typography>
      <Icons.Close />
    </IconButton>
  );
};

export default CloseButton;
